import { RQAPICallWithData } from 'store/APIClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { EditChartTemplateDataT } from '../../types';
import { useDispatch } from 'store/hooks';

const updateChartTemplate = async (
    templateKey: number,
    editChartTemplateData: EditChartTemplateDataT,
): Promise<{ message: string }> => {
    const response = await RQAPICallWithData({
        endpoint: `support/chart_templates/${templateKey}`,
        body: editChartTemplateData,
        method: 'PUT',
    });
    return response.content;
};

export const useUpdateChartTemplate = (templateKey: number) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: ['update-chart-template'],

        mutationFn: async ({
            editChartTemplateData,
        }: {
            editChartTemplateData: EditChartTemplateDataT;
        }) => updateChartTemplate(templateKey, editChartTemplateData),
        meta: { useGlobalOnError: true },
        onSuccess: ({ message }) => {
            queryClient.invalidateQueries({
                queryKey: ['chart-templates-table-items'],
            });
            dispatch.vision.notifyUser({
                message,
                snackType: 'success',
            });
        },
    });
};
